import { createContext, type RefObject, use } from "react";

export interface DialogRootInterface {
  contentRef?: RefObject<HTMLDivElement>;
}

export const DialogRootContext = createContext<DialogRootInterface>({});

export const useDialogRootContext = () => use(DialogRootContext);
